
import MapCommand from './MapCommand';

export default class MapCommandSetMapTool extends MapCommand {

    constructor(options) {
        super(options);
        this._name = 'SET_MAP_TOOL';
    }

    execute(olMap, params) {
        let map = olMap.getMap();
        let interactions = map.getInteractions();
        interactions.forEach(interaction => {
            let mapToolId = interaction.get('mapToolId');
            if (mapToolId) {
                if (mapToolId === params.toolId) {
                    interaction.setActive(true);
                } else {
                    interaction.setActive(false);

                }
            }
        });
    }
}
